"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoMeeting/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');


var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _videoRoom = require('web/actions/videoRoom');
var _VideoCall = require('web/screens/VideoCall'); var _VideoCall2 = _interopRequireDefault(_VideoCall);
var _VideoRooms = require('web/screens/VideoRooms'); var _VideoRooms2 = _interopRequireDefault(_VideoRooms);
var _VideoCallOverlay = require('web/screens/VideoMeeting/VideoCallOverlay'); var _VideoCallOverlay2 = _interopRequireDefault(_VideoCallOverlay);
var _RoomModalsScreen = require('web/screens/VideoMeeting/RoomModalsScreen'); var _RoomModalsScreen2 = _interopRequireDefault(_RoomModalsScreen);
var _videoCall = require('web/selectors/videoCall');



var _videoRoom3 = require('web/selectors/videoRoom');

var _hooks = require('web/services/hooks');
var _ui = require('web/services/ui');





var _videoCall3 = require('web/services/videoCall');
var _bus = require('shared/services/bus'); var _bus2 = _interopRequireDefault(_bus);




































const twoMinutesInMs = 2 * 60 * 1000

const VideoMeeting = ({
  isLoggedIn = false,
  showNoticeBar,
  isJoinCallModalOpen,
  openJoinCallModal,
  closeJoinCallModal,
  isMobileNewRoomModalOpen,
  isDesktopNewRoomModalOpen,
  openMobileNewRoomModal,
  openDesktopNewRoomModal,
  closeNewRoomModal,
}) => {
  const history = _reactrouterdom.useHistory.call(void 0, )
  const roomLink = _hooks.useAppSelector.call(void 0, _videoRoom3.selectCurrentVideoRoomLink)
  const isOnCall = _hooks.useAppSelector.call(void 0, _videoCall.selectIsOnCall)

  // Was the constructor: switching between V1/V2 clients before initial render.
  _react.useState.call(void 0, () => _actions2.default.setVideoRoomWSHandlers(isLoggedIn))

  const [isMobileMoreOptionsModalOpen, setIsMobileMoreOptionsModalOpen] = _react.useState.call(void 0, false)
  const [isMoreOptionsSettingsEnabled, setIsMoreOptionsSettingsEnabled] = _react.useState.call(void 0, false)
  const [isMoreOptionsNetstatsEnabled, setIsMoreOptionsNetstatsEnabled] = _react.useState.call(void 0, false)
  const [isSettingsModalOpen, setIsSettingsModalOpen] = _react.useState.call(void 0, false)
  const [isNetstatsModalOpen, setIsNetstatsModalOpen] = _react.useState.call(void 0, false)
  const [isFeedbackRatingModalOpen, setIsFeedbackRatingModalOpen] = _react.useState.call(void 0, false)
  const [isVideoOverlayMinimized, setIsVideoOverlayMinimized] = _react.useState.call(void 0, false)

  // Was an instance field: one mutable object for the component's lifetime,
  // handed to the settings modal, whose callback openSettingsModal replaces.
  const [settingsModalContext] = _react.useState(() => ({}))

  // The class handlers read `this.props`/`this.state` when called; these refs
  // give the stable callbacks below the same latest values.
  const latest = _react.useRef.call(void 0, { roomLink, showNoticeBar, isOnCall, openJoinCallModal, isVideoOverlayMinimized })
  _react.useLayoutEffect.call(void 0, () => {
    latest.current = { roomLink, showNoticeBar, isOnCall, openJoinCallModal, isVideoOverlayMinimized }
  })
  const displayedNetworkProblems = _react.useRef({})

  const handleVideoOverlayMinimization = _react.useCallback.call(void 0, (isMinimized) =>
    setIsVideoOverlayMinimized(isMinimized), [])

  const openMobileMoreOptionsModal = _react.useCallback.call(void 0, ({
    isSettingsLinkEnabled = true,
    isNetstatsLinkEnabled = false,
  } = {}) => {
    setIsMoreOptionsSettingsEnabled(isSettingsLinkEnabled)
    setIsMoreOptionsNetstatsEnabled(isNetstatsLinkEnabled)
    setIsMobileMoreOptionsModalOpen(true)
  }, [])

  const closeMobileMoreOptionsModal = _react.useCallback.call(void 0, () => setIsMobileMoreOptionsModalOpen(false), [])
  const openSettingsModal = _react.useCallback.call(void 0, (cb) => {
    settingsModalContext.cb = cb
    setIsSettingsModalOpen(true)
  }, [settingsModalContext])

  const closeSettingsModal = _react.useCallback.call(void 0, () => setIsSettingsModalOpen(false), [])
  const openNetstatsModal = _react.useCallback.call(void 0, () => setIsNetstatsModalOpen(true), [])
  const closeNetstatsModal = _react.useCallback.call(void 0, () => setIsNetstatsModalOpen(false), [])
  const openFeedbackRatingModal = _react.useCallback.call(void 0, () => setIsFeedbackRatingModalOpen(true), [])
  const closeFeedbackRatingModal = _react.useCallback.call(void 0, () => setIsFeedbackRatingModalOpen(false), [])

  const showCallOverlay = _react.useCallback.call(void 0, () => _actions2.default.setIsOnCall(true), [])
  const hideCallOverlay = _react.useCallback.call(void 0, () => _actions2.default.setIsOnCall(false), [])

  const handleGracefulCallExit = _react.useCallback.call(void 0, () => {
    hideCallOverlay()
    openFeedbackRatingModal()
  }, [hideCallOverlay, openFeedbackRatingModal])

  const handleForcefulCallExit = _react.useCallback.call(void 0, () => hideCallOverlay(), [hideCallOverlay])

  const handleRoomLinkCopy = _react.useCallback.call(void 0, () => _ui.copyToClipboard.call(void 0, latest.current.roomLink)
    .then(() => latest.current.showNoticeBar({
      type: 'success', text: 'Link copied to clipboard.',
    }))
    .catch(e => {
      log.error(e)
      latest.current.showNoticeBar({
        type: 'warning', text: 'Failed to copy link.',
      })
    }), [])

  const handleRoomShare = _react.useCallback.call(void 0, () => _ui.nativeShare.call(void 0, {
    url: latest.current.roomLink,
    title: 'Call invitation',
    text: 'Join the call',
  }).catch(handleRoomLinkCopy), [handleRoomLinkCopy])

  const handleUserProblemEncountered = _react.useCallback.call(void 0, (action, state) => {
    const { RoomUserKey, RoomKey, ProblemCode, ProblemReportedAt } = action.payload 

    if (!ProblemCode) return
    // The class read the user through a mapState closure over the store; the
    // bus hands the handler the store state after this action.
    // SAFETY: the bus passes the web store's state, which has the video slices.
    const user = _videoRoom3.selectVideoRoomUser.call(void 0, RoomUserKey, RoomKey, state ) || {}

    // Don't display a network problem from a single
    // user more often than once every 2 minutes.
    if (ProblemCode === _videoCall3.problemCodes.NETWORK) {
      if ((ProblemReportedAt ) - displayedNetworkProblems.current[RoomKey + RoomUserKey] < twoMinutesInMs) { return }
      displayedNetworkProblems.current[RoomKey + RoomUserKey] = Date.now()
    }

    latest.current.showNoticeBar({
      type: 'warning',
      text: _videoCall3.formatDisplayErrorMessage.call(void 0, user.RoomUserName, ProblemCode),
    })
  }, [])

  // Class lifecycle timing (componentDidMount / componentWillUnmount).
  _react.useLayoutEffect.call(void 0, () => {
    _videoCall3.refreshDevicesList.call(void 0, )
    _videoCall3.bindDevicesListListener.call(void 0, )
    _bus2.default.on(
      _videoRoom.types.VIDEO_ROOM_USER_PROBLEM_ENCOUNTERED,
      handleUserProblemEncountered,
    )
    return () => {
      _actions2.default.unsetVideoRoomWSHandlers()
      _videoCall3.unbindDevicesListListener.call(void 0, )
      _bus2.default.off(
        _videoRoom.types.VIDEO_ROOM_USER_PROBLEM_ENCOUNTERED,
        handleUserProblemEncountered,
      )
    }
  }, [handleUserProblemEncountered])

  const gotoRoomsList = _react.useCallback.call(void 0, () =>
    history.push('/vd/'), [history])

  const gotoRoom = _react.useCallback.call(void 0, (roomId) => {
    _actions2.default.setCurrentVideoRoomKey(roomId)
    history.push(`/vd/${roomId}`)
  }, [history])

  const gotoMeeting = _react.useCallback.call(void 0, () => {
    const { isOnCall, openJoinCallModal, isVideoOverlayMinimized } = latest.current
    if (!isOnCall) return openJoinCallModal()

    if (isVideoOverlayMinimized) { return handleVideoOverlayMinimization(false) }
    log.error("User attempted to join a video call during another call and their feed wasn't minimized o_O.")
    return undefined
  }, [handleVideoOverlayMinimization])

  // The class passed `this.handleCallJoinFailed`, which it never defined, so
  // children always received `undefined`. Kept as is.
  const handleCallJoinFailed = undefined

  const renderVideoCall = ({ match }) => (
    _react2.default.createElement(_VideoCall2.default, {
      roomKey: match.params.roomKey,
      onRoomShare: handleRoomShare,
      onRoomLinkCopy: handleRoomLinkCopy,
      openMobileMoreOptionsModal: openMobileMoreOptionsModal,
      openSettingsModal: openSettingsModal,
      isNetstatsModalOpen: isNetstatsModalOpen,
      openNetstatsModal: openNetstatsModal,
      closeNetstatsModal: closeNetstatsModal,
      showNoticeBar: showNoticeBar,
      onCallJoinFailed: handleCallJoinFailed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 216}}
    )
  )

  const renderMeetingRoom = ({ match }) => (
    _react2.default.createElement(_VideoRooms2.default, {
      roomKey: match.params.roomKey,
      gotoMeeting: gotoMeeting,
      gotoRoom: gotoRoom,
      gotoRoomsList: gotoRoomsList,
      onRoomShare: handleRoomShare,
      onRoomLinkCopy: handleRoomLinkCopy,
      showNoticeBar: showNoticeBar,
      isMobileNewRoomModalOpen: isMobileNewRoomModalOpen,
      isDesktopNewRoomModalOpen: isDesktopNewRoomModalOpen,
      openMobileNewRoomModal: openMobileNewRoomModal,
      openDesktopNewRoomModal: openDesktopNewRoomModal,
      closeNewRoomModal: closeNewRoomModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 231}}
    )
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  isOnCall &&
        _react2.default.createElement(_VideoCallOverlay2.default, {
          showNoticeBar: showNoticeBar,
          openMobileMoreOptionsModal: openMobileMoreOptionsModal,
          openSettingsModal: openSettingsModal,
          isNetstatsModalOpen: isNetstatsModalOpen,
          openNetstatsModal: openNetstatsModal,
          closeNetstatsModal: closeNetstatsModal,
          onRoomLinkCopy: handleRoomLinkCopy,
          onRoomShare: handleRoomShare,
          onGracefulExit: handleGracefulCallExit,
          onForcefulExit: handleForcefulCallExit,
          isMinimizable: isLoggedIn,
          isMinimized: isVideoOverlayMinimized,
          handleMinimization: handleVideoOverlayMinimization,
          gotoFeedback: openFeedbackRatingModal,
          onCallJoinFailed: handleCallJoinFailed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}}
        )
      
      , _react2.default.createElement(_RoomModalsScreen2.default, {
        onRoomShare: handleRoomShare,
        onRoomLinkCopy: handleRoomLinkCopy,
        isMobileMoreOptionsModalOpen: isMobileMoreOptionsModalOpen,
        isMoreOptionsSettingsEnabled: isMoreOptionsSettingsEnabled,
        isMoreOptionsNetstatsEnabled: isMoreOptionsNetstatsEnabled,
        closeMobileMoreOptionsModal: closeMobileMoreOptionsModal,

        isSettingsModalOpen: isSettingsModalOpen,
        settingsModalContext: settingsModalContext,
        openSettingsModal: openSettingsModal,
        closeSettingsModal: closeSettingsModal,

        openNetstatsModal: openNetstatsModal,

        isJoinCallModalOpen: isJoinCallModalOpen,
        openJoinCallModal: openJoinCallModal,
        closeJoinCallModal: closeJoinCallModal,
        gotoMeeting: showCallOverlay,

        isMobileNewRoomModalOpen: isMobileNewRoomModalOpen,
        isDesktopNewRoomModalOpen: isDesktopNewRoomModalOpen,
        closeNewRoomModal: closeNewRoomModal,

        isFeedbackRatingModalOpen: isFeedbackRatingModalOpen,
        closeFeedbackRatingModal: closeFeedbackRatingModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 268}}
      )
      , _react2.default.createElement(_reactrouterdom.Switch, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 295}}
        , _react2.default.createElement(_reactrouterdom.Route, {
          path: "/vd/:roomKey?",
          render: isLoggedIn
            ? renderMeetingRoom
            : renderVideoCall
          , __self: this, __source: {fileName: _jsxFileName, lineNumber: 296}}
        )
      )
    )
  )
}

// connect() memoised the component on its props; memo keeps that boundary.
exports. default = _react.memo.call(void 0, VideoMeeting)
